import { createRouter, createWebHashHistory } from "vue-router";

import store from "./store/index.js";

import HomePage from "./pages/HomePage.vue";

const router = createRouter({
  mode: "hash",
  history: createWebHashHistory(),
  routes: [
    { path: "/", component: HomePage },
    { path: "/:pathMatch(.)", redirect: "/" },
    { path: "/:pathMatch(.*)", redirect: "/" },
    { path: "/:pathMatch(.*)*", redirect: "/" },
    { path: "/home", component: HomePage },
    { path: "/unsubscribe", component: HomePage },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((route) => route.meta.requiresAuth)) {
    if (store.state.tournamentCode) {
      next();
    } else {
      next("/");
    }
  } else {
    next();
  }
});

export default router;
